import type { RouteRecordRaw } from 'vue-router';
import { useAdminNavStore } from '@/modules/admin/stores/admin-nav';

export const adminStoriesRoute: RouteRecordRaw = {
  path: `/admin/stories`,
  name: 'adminStories',
  component: () => import('@/modules/admin-stories/views/StoriesAdmin.vue'),
  beforeEnter: () => {
    const store = useAdminNavStore();
    store.navItems = [];
  },
  meta: {
    layout: 'admin',
  },
};
